module.exports = __webpack_public_path__ + "static/media/home_5.a6eab3d9.jpg";